export const classes = {
  dialog: 'w-[600px] max-w-full min-w-[150px]',
  body: 'w-full pt-2 pb-12 overflow-auto text-center text-grey-7 dark:text-mauve-2 flex flex-col items-center',
  tooltip: 'max-w-full',
  copy: 'font-normal text-sm sm:text-lg text-grey-7 dark:text-mauve-2 my-1 cursor-pointer hover:underline p-4 bg-grey-1 dark:bg-white/[0.06] hover:bg-grey-2 dark:hover:bg-white/[0.1] rounded border border-grey-4 dark:border-white/10 break-all',
  qrCode: 'mb-6 p-3 rounded border border-grey-5 dark:border-white/10',
};
